import {h, text, handler, data} from '../h'
import {Tabs} from '../navigation/tab'

import './index.css'

export function TabsHeader() {
  h('nav', () => {
    data({tabHeaders: true})
    Tabs(({select, selected, title, name}) => {
      h('div', () => {
        data({
          tabHeader: true,
          tabHeaderSelected: selected,
          tabName: name
        })
        handler({click: select})
        text(title)
      })
    })
  })
}
